exports = module.exports = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".applied-filters-container[data-v-c1ad87b2]{font-size:10px}", ""]);
